import { PERSONALIZED_TOP_OFFERS_VIEW } from './types';

export const triggerPersonalizedTopOffersIsViewed = () => ({
  type: PERSONALIZED_TOP_OFFERS_VIEW,
});
